
<q-tr
  v-if="!mobile"
  :props="props"
  class="table-mode cmp-domain-result-item"
  :class="{
    'ws-dark': dark || isTheme(Theme.LOOPIA),
    'ws-highlighted': highlighted,
    occupied: domain && !domain.availableForPurchase,
    'is-loading': isLoading,
    'for-sale': forSale,
    error: hasAnyError,
  }"
  @click="buy"
>
  <domain-title
    v-if="domain"
    class="td-domain"
    :props="props"
    :in-cart="isInCart"
  />
  <bundle-title
    v-else-if="bundle"
    class="td-domain"
    :dark="dark"
    :highlighted="highlighted"
    :props="props"
  />

  <template v-if="hasError">
    <q-td key="period" :props="props" class="td-period">
      <small class="table-item-status text-ws-error">
        <strong>{{ $t('domain_checker.error') }}</strong>
      </small>
    </q-td>

    <!-- PRICE cell colspanned to 2 cells-->
    <q-td
      key="price"
      :props="props"
      class="td-price text-right text-ws-error q-pr-md"
      colspan="2"
    >
      <small class="q-pr-md">{{ $t(error) }}</small>
    </q-td>
  </template>
  <template v-else>
    <template v-if="bundle || domain.availableForPurchase || isInCart">
      <!-- PERIOD cell -->
      <q-td key="period" :props="props" class="td-period ws-text-primary">
        <ws-period
          v-if="!isTransferInCart || bundle"
          :period="bundle ? bundle.mainDomain.period : domain.period"
        />
      </q-td>

      <!-- PRICE cell -->
      <q-td key="price" :props="props" class="td-price text-right">
        <price-cell
          :price="price"
          :period="period"
          :prolong-period="prolongPeriod"
          :transfer="isTransferInCart"
        />
      </q-td>
    </template>

    <!-- CTAs -->
    <q-td
      key="action"
      class="td-action"
      :props="props"
      :colspan="bundle || domain.availableForPurchase || isInCart ? 1 : 3"
    >
      <ctas
        ref="ctas"
        :transfer-in-cart="domain ? isTransferInCart : false"
        :in-cart="isInCart"
        :loading="isLoading"
        :domain="domain"
        :bundle="bundle"
        :path="path"
        :error="hasAnyError"
      />
    </q-td>
  </template>
</q-tr>

<!-- MOBILE VIEW -->
<!-- The buy functionality is also available by clicking the button inside this div,
      so it is okay that this is not a button. -->
<!-- eslint-disable
     vuejs-accessibility/click-events-have-key-events
     vuejs-accessibility/no-static-element-interactions
-->
<div
  v-else
  class="mobile cmp-domain-result-item"
  :class="{
    'ws-dark': dark || isTheme(Theme.LOOPIA),
    'ws-highlighted': highlighted,
    occupied: domain && !domain.availableForPurchase,
    'is-loading': isLoading,
    'for-sale': forSale,
    error: hasAnyError,
  }"
  @click="buy"
>
  <!-- eslint-enable
   vuejs-accessibility/click-events-have-key-events
   vuejs-accessibility/no-static-element-interactions
  -->
  <div class="domain-info-col">
    <!-- DOMAIN -->
    <template v-if="domain">
      <domain-title mobile :props="props" :in-cart="isInCart" />

      <div
        v-if="!domain.availableForPurchase"
        key="period"
        :props="props"
        class="grid-item-status text-uppercase"
        :class="{ 'text-ws-error': hasError }"
      >
        {{
          hasError
            ? $t('domain_checker.error')
            : $t('domain_checker.occupied.short_status')
        }}
      </div>

      <!-- PRICE cell -->
      <div v-else>
        <div
          v-if="!hasError"
          key="price"
          :props="props"
          class="grid-item-price"
        >
          <price-cell
            :price="price"
            :period="period"
            :prolong-period="prolongPeriod"
            :transfer="isTransferInCart"
          />
        </div>
        <div v-else key="price" :props="props" class="grid-item-price">
          {{ $t(error) }}
        </div>
      </div>
    </template>

    <!-- BUNDLE -->
    <template v-else-if="bundle">
      <div class="domain-info-col">
        <bundle-title mobile :props="props" />

        <!-- PRICE cell -->
        <div key="price" :props="props" class="grid-item-price">
          <price-cell
            :price="price"
            :period="period"
            :prolong-period="prolongPeriod"
          />
        </div>
      </div>
    </template>
  </div>

  <!-- CTAs -->
  <div key="action" class="item-ctas flex items-center no-wrap">
    <ws-message type="alert" inline class="q-mx-md" :path="path">
      {{
        hasError ? $t(error) : ''
      }}
    </ws-message>
    <ctas
      v-if="!hasError"
      ref="ctas"
      mobile
      :transfer-in-cart="domain ? isTransferInCart : false"
      :in-cart="isInCart"
      :loading="isLoading"
      :domain="domain"
      :bundle="bundle"
      :path="path"
      :error="hasAnyError"
    />
  </div>
</div>
